import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userService, authService } from '../../services/api';
import AppAlert from '../../components/AppAlert';
import LoadingSpinner from '../../components/LoadingSpinner';

const ProfilePage = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState({
        name: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        const loadUser = () => {
            const userData = authService.getCurrentUser();
            if (userData) {
                setCurrentUser(userData);
                setUser(prev => ({
                    ...prev,
                    name: userData.name || '',
                    email: userData.email || '',
                    phone: userData.phone || ''
                }));
            }
        };
        loadUser();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUser(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMessage('');
        setIsLoading(true);

        // Validação básica de senha
        if (user.password && user.password !== user.confirmPassword) {
            setError('As senhas não coincidem.');
            setIsLoading(false);
            return;
        }

        try {
            const updateData = {
                name: user.name,
                phone: user.phone
            };

            if (user.password) {
                updateData.password = user.password;
            }

            // Usando ID do usuário atual
            const userId = currentUser.userId || currentUser.id;
            await userService.update(userId, updateData);

            setSuccessMessage('Dados atualizados com sucesso!');

            // Limpa campos de senha
            setUser(prev => ({
                ...prev,
                password: '',
                confirmPassword: ''
            }));

        } catch (err) {
            console.error('Erro ao atualizar perfil:', err);
            setError(err.response?.data?.message || 'Erro ao atualizar dados. Tente novamente.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="page-container">
            <div className="card-modern" style={{ maxWidth: '600px', margin: '0 auto' }}>
                <div className="card-modern-header">
                    <h2 className="page-title" style={{ fontSize: '1.5rem', margin: 0 }}>
                        <i className="fa-solid fa-user-gear page-title-icon" style={{ fontSize: '1.5rem' }}></i>
                        Minha Conta
                    </h2>
                </div>

                <div className="card-modern-body">
                    {error && (
                        <AppAlert
                            variant="error"
                            message={error}
                            onClose={() => setError('')}
                            style={{ marginBottom: 16 }}
                        />
                    )}

                    {successMessage && (
                        <AppAlert
                            variant="success"
                            message={successMessage}
                            onClose={() => setSuccessMessage('')}
                            style={{ marginBottom: 16 }}
                        />
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="email" className="form-label">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={user.email}
                                disabled
                                className="form-input"
                                style={{ backgroundColor: '#f8fafc', cursor: 'not-allowed', opacity: 0.7 }}
                            />
                            <small style={{ color: 'var(--text-muted)', marginTop: '6px', display: 'block', fontSize: '13px' }}>
                                O email não pode ser alterado.
                            </small>
                        </div>

                        <div className="form-group">
                            <label htmlFor="name" className="form-label">Nome Completo</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={user.name}
                                onChange={handleChange}
                                required
                                className="form-input"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone" className="form-label">Telefone</label>
                            <input
                                type="text"
                                id="phone"
                                name="phone"
                                value={user.phone}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="(00) 00000-0000"
                            />
                        </div>

                        <div className="divider" style={{ margin: '30px 0' }}>
                            <span>Alterar Senha</span>
                        </div>

                        <div className="form-group">
                            <label htmlFor="password" className="form-label">Nova Senha</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={user.password}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Mínimo 6 caracteres"
                                minLength={6}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirmPassword" className="form-label">Confirmar Nova Senha</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                value={user.confirmPassword}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Repita a nova senha"
                            />
                        </div>

                        <div className="form-actions" style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate(-1)}
                            >
                                Voltar
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isLoading}
                            >
                                {isLoading ? <LoadingSpinner size="sm" color="#fff" /> : 'Salvar Alterações'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
